import React from "react";
import "./Hello.css";

function Hello() {
  const sayHello = () => {
    window.alert("HEY THERE !");
  };

  const sayName = (name) => {
    window.alert(`Hey There, ${name} !`);
  };
  return (
    <div className="hello">
      <button onClick={sayHello} className="btn">
        Click Me !
      </button>
      {/* To attach a function to event listener WITH PARAMETERS, we need to put the function inside an anonymous arrow function */}
      <button
        onClick={() => {
          sayName("Stewie");
        }}
        className="btn"
      >
        Try me !
      </button>
    </div>
  );
}

export default Hello;
